import { render, staticRenderFns } from "./CatalogSkeletonLoader.vue?vue&type=template&id=0fa250c9&scoped=true&"
import script from "./CatalogSkeletonLoader.vue?vue&type=script&lang=js&"
export * from "./CatalogSkeletonLoader.vue?vue&type=script&lang=js&"
import style0 from "./CatalogSkeletonLoader.vue?vue&type=style&index=0&id=0fa250c9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa250c9",
  null
  
)

export default component.exports